import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { IDeviceInfoModel } from '../models/device-info.model';

@Injectable()
export class WebRtcInfoService {
  private webRTCAvailable = false;
  private getDeviceInfo$ = new Subject<IDeviceInfoModel>();

  public constructor() {
    type LegacyGetUserMedia = typeof navigator.mediaDevices.getUserMedia;
    type LegacyNavigator = Navigator & {
      getUserMedia?: LegacyGetUserMedia;
      webkitGetUserMedia?: LegacyGetUserMedia;
      mozGetUserMedia?: LegacyGetUserMedia;
    };
    const legacyNavigator = navigator as LegacyNavigator;
    const getUserMedia = (navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
      || legacyNavigator.getUserMedia
      || legacyNavigator.webkitGetUserMedia
      || legacyNavigator.mozGetUserMedia;

    this.webRTCAvailable = !!getUserMedia;

    if (this.webRTCAvailable && typeof navigator.mediaDevices === 'object') {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          let hasAudio = false;
          let hasVideo = false;

          const devicesLength = devices.length;
          for (let i = 0; i < devicesLength; i++) {
            if (devices[i].kind === 'videoinput') {
              hasVideo = true;
            }
            else if (devices[i].kind === 'audioinput') {
              hasAudio = true;
            }
          }

          this.getDeviceInfo$.next({
            hasVideo: hasVideo,
            hasAudio: hasAudio
          });
        })
        .catch((error: unknown) => console.error(error));

      return;
    }

    this.getDeviceInfo$.next({
      hasVideo: false,
      hasAudio: false
    });
  }

  public isAvailable(): boolean {
    return this.webRTCAvailable;
  }

  public getDeviceInfo(): Observable<IDeviceInfoModel> {
    return this.getDeviceInfo$;
  }
}
